import { Observable } from "rxjs";

export abstract class AbstractUserEventConfig {
    abstract getCurrentCustomerInfo(): Observable<{ customer_name: string, account_type: string }>
}
